module.exports = __webpack_public_path__ + "static/fonts/Fact-MediumItalic.87c6490.eot";